import React, { useEffect } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
// import CountUp from "react-countup";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Breadcrumbs from "../common/breadcrumbs";
import Aos from "aos";
import { Link } from "react-router-dom";
import { testimonialsData } from "../../core/data/json/testimonials_data";
import { allFaqsNamo } from "../../functionsMaster";

const AboutUs = () => {
  const testimonials = testimonialsData;


  const setting = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
  };
  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);
  return (
    <>
      {/* Breadscrumb Section */}
      <Breadcrumbs title="Page" subtitle="About Us" />
      {/* /Breadscrumb Section */}
      {/* About */}
      <section className="section about-sec">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6" data-aos="fade-down">
              <div className="about-img">
                <div className="about-exp">
                  <span>12+ years of experiences</span>
                </div>
                <div className="abt-img">
                  <ImageWithBasePath
                    src="assets/img/about-us.png"
                    className="img-fluid"
                    alt="About us"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-down">
              <div className="about-content">
                <h6>About us</h6>
                <h2>Namo Cars - Self Drive Car Rental in Udaipur</h2>
                <p>
                  At Namo Cars, we make self-drive car rentals in Udaipur simple, safe, and seamless. Whether you need a car on rent without a driver for a business trip, weekend getaway, or airport pickup, we’ve got you covered. As one of the best self drive car rental services in Rajasthan, we offer a wide range of clean, well-maintained vehicles—from hatchbacks and sedans to premium SUVs.
                </p>
                <p>
                  Our mission is to give you the freedom to drive your way, with affordable pricing, flexible rental plans, and 24X7 customer support. Enjoy doorstep car delivery, quick online booking, and transparent policies that ensure a stress-free travel experience. Every Namo Cars vehicle comes with regular maintenance, insurance, and roadside assistance—so your journey stays safe and enjoyable.
                </p>
                <p>
                  With multiple pickup and drop-off points across Udaipur, we make it easy to rent a car near Udaipur Airport, city center, or tourist destinations like Fateh Sagar Lake and City Palace. Whether you’re exploring Rajasthan, attending a wedding, or traveling for work, Namo Cars is your trusted self-drive car partner.
                </p>
                <p>
                  <Link to="/listings/cars">
                    Book online, pick your favorite car, and hit the road.
                  </Link>
                </p>
                <b>
                  Drive your way. Drive with Namo Cars.
                </b>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About us Testimonials */}

      <section className="section about-testimonial testimonials-section">
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading" data-aos="fade-down">
            <h2 className="title text-white">What People say about us? </h2>
            <p className="description text-white">
              Discover what our customers have think about us
            </p>
          </div>
          {/* /Heading title */}
          <div className="owl-carousel about-testimonials testimonial-group mb-0 owl-theme">
            {/* /Carousel Item  */}
            {/* Carousel Item */}
            <Slider {...setting}>
              {testimonials.map((testimonial) => (
                <a href="https://maps.app.goo.gl/j8cL9TVnUZ1dVW9F9" target="_BLANK" rel="noreferrer" key={testimonial.id} className="testimonial-item d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="quotes-head" />
                      <div className="review-box">
                        <div className="review-profile">
                          <div className="review-img">
                            <img
                              src={testimonial.image}
                              className="img-fluid"
                              alt="img"
                            />
                          </div>
                        </div>
                        <div className="review-details">
                          <h6>{testimonial.name}</h6>
                          <div className="list-rating">
                            <div className="list-rating-star">
                              {[...Array(Math.floor(testimonial.rating))].map(
                                (_, i) => (
                                  <i key={i} className="fas fa-star filled" />
                                )
                              )}
                            </div>
                            <p>
                              <span>({testimonial.rating})</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <p>{testimonial.review}</p>
                    </div>
                  </div>
                </a>
              ))}
            </Slider>

            {/* /Carousel Item  */}
            {/* Carousel Item */}

            {/* /Carousel Item  */}
          </div>
        </div>
      </section>
      {/* About us Testimonials */}
      <>
        {/* FAQ  */}
        <section className="section faq-section bg-light-primary">
          <div className="container">
            {/* Heading title*/}
            <div className="section-heading" data-aos="fade-down">
              <h2>Frequently Asked Questions </h2>
              <p>Find answers to your questions from our previous answers</p>
            </div>
            {/* /Heading title */}
            <div className="faq-info">
              {allFaqsNamo.map((s, i) => (
                <div className="faq-card bg-white" key={`faqs${i}`} data-aos="fade-down">
                  <h4 className="faq-title">
                    <Link
                      className="collapseds"
                      data-bs-toggle="collapse"
                      to={`#faqs${i}`}
                      aria-expanded={i === 0}
                    >
                      {s.question}
                    </Link>
                  </h4>
                  <div id={`faqs${i}`} className={`card-collapse collapse ${i === 0 ? 'show' : ''}`}>
                    <p>{s.answer}</p>
                  </div>
                </div>
              ))}

            </div>
          </div>
        </section>
        {/* /FAQ */}
      </>
    </>
  );
};

export default AboutUs;
